import React from 'react';
import MessageList from './MessageList';
import ChatInput, { ChatInputRef } from './ChatInput';
import MobileFooter from './MobileFooter';

interface ChatContainerProps {
  messages: any[];
  isLoading: boolean;
  currentStatus: string | undefined;
  currentTool: string | undefined;
  error: string | null | undefined;
  apiHealthy: boolean;
  input: string;
  hasUserInteracted: boolean;
  elapsedTime: number;
  messagesEndRef: React.RefObject<HTMLDivElement | null>;
  chatInputRef?: React.RefObject<ChatInputRef | null>;
  onSubmit: (e: React.FormEvent) => void;
  onInputChange: (value: string) => void;
  onQuickAction: (question: string) => void;
  onClearError: () => void;
  onShowFeedback: () => void;
  onShowMobileSidebar: (section: 'about' | 'sources') => void;
  getContextualPlaceholder: () => string;
  t: any;
}

const ChatContainer: React.FC<ChatContainerProps> = ({
  messages,
  isLoading,
  currentStatus,
  currentTool,
  error,
  apiHealthy,
  input,
  hasUserInteracted,
  elapsedTime,
  messagesEndRef,
  chatInputRef,
  onSubmit,
  onInputChange,
  onQuickAction,
  onClearError,
  onShowFeedback,
  onShowMobileSidebar,
  getContextualPlaceholder,
  t
}) => {
  return (
    <div className="bg-white lg:rounded-2xl lg:shadow-xl lg:border lg:border-gray-200 lg:m-4 overflow-hidden flex flex-col flex-1">
      
      {/* Chat Header */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-2 md:p-2.5 sm:p-3 flex-shrink-0 shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-1 md:space-x-1.5 sm:space-x-2 flex-1 min-w-0">
            <span className="text-blue-100 text-xs font-medium truncate">💬 {t('chat.welcomeTitle')}</span>
          </div>
          
          <div className="flex items-center space-x-1 md:space-x-1.5 flex-shrink-0">
            <button
              onClick={onShowFeedback}
              className="bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white px-1.5 py-1 md:px-2 md:py-1 sm:px-3 sm:py-1.5 rounded md:rounded-lg text-xs font-medium transition-all shadow-lg active:scale-95"
            >
              <span className="hidden sm:inline">{t('feedback.ctaText')}</span>
              <span className="sm:hidden">💬</span>
            </button>
          </div>
        </div>
      </div>

      {/* FIXED: Messages area - this is the flexible, scrollable part */}
      <MessageList
        messages={messages}
        isLoading={isLoading}
        currentStatus={currentStatus}
        currentTool={currentTool}
        error={error}
        hasUserInteracted={hasUserInteracted}
        elapsedTime={elapsedTime}
        messagesEndRef={messagesEndRef}
        onQuickAction={onQuickAction}
        onClearError={onClearError}
        onShowFeedback={onShowFeedback}
        t={t}
      />

      {/* FIXED: Input area - fixed at bottom */}
      <ChatInput
        ref={chatInputRef}
        input={input}
        isLoading={isLoading}
        apiHealthy={apiHealthy}
        onSubmit={onSubmit}
        onInputChange={onInputChange}
        getContextualPlaceholder={getContextualPlaceholder}
        t={t}
      />

      {/* FIXED: Mobile footer - fixed at bottom */}
      <MobileFooter 
        onShowMobileSidebar={onShowMobileSidebar}
        t={t}
      />
    </div>
  );
};

export default ChatContainer;